module.exports = __webpack_public_path__ + "img/1.1ff9f823.jpg";